import { css, Theme } from '@emotion/react'

export const title = (theme: Theme) => css`
  display: block;
  margin-top: ${theme.spacing(3)};

  font-size: 22px;
  font-weight: 700;
`

export const charts = (theme: Theme) => css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(3)};

  ${theme.breakpoints.down(680)} {
    grid-template-columns: 1fr;
  }
`

export const chartCard = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};

  border-radius: 14px;
  border: 1px solid ${theme.colors.backgroundOne};
  padding: 23px;
  box-shadow: ${theme.boxShadows.small};
`

export const emptyCard = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;

  padding: 31px 14px;
  color: ${theme.typographyColors.typographyFour};
`

export const chartWrapper = css`
  position: relative;

  margin: 0 auto;
  height: 205px;
`

export const centerText = css`
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  text-align: center;
  max-width: 70%;
`

export const hours = (theme: Theme) => css`
  font-size: 30px;
  font-weight: 700;
  color: ${theme.colors.typographyOne};
`

export const hoursLabel = (theme: Theme) => css`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: ${theme.colors.typographyTwo};
`

export const ul = css`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin: 0;
  padding: 0;
  list-style: none;
`

export const li = css`
  display: flex;
  justify-content: space-between;
`

export const subjectName = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const dotWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 10px;
  height: 10px;
  border-radius: 50%;
`

export const dot = (color: string, hovered: boolean) =>
  css`
    width: 6px;
    height: 6px;
    border-radius: 50%;

    background-color: ${color};

    transition: width 200ms ease-in-out, height 200ms ease-in-out;

    ${hovered &&
    css`
      width: 10px;
      height: 10px;
    `}
  `

export const subjectNameTypography = (theme: Theme) => css`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.typographyOne};
`

export const time = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`
